export const jeyhoonPhoneNumber = '021-92000998'
export const jeyhoonMail = 'Info@jeyhoon.org'
export const jeyhoonLinkedin = 'https://www.linkedin.com/company/jeyhoon/'
